import { BaseCategory } from "./BaseCategory";
import { HeaderPositionType, ListStyleType, TextStyleType, TrayType } from "../constants";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class BeforeAfterCategory extends BaseCategory {
    get name() {
        return "Before and After";
    }

    get type() {
        return SlideCategories.BEFORE_AFTER;
    }

    get icon() {
        return null;
    }

    get description() {
        return "Use for showing a comparison between a before state and an after state, such as process improvements, transformations, or changes over time.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Create a before and after comparison for the slide based on the user's prompt.
        Provide a list of items for the "before" state and corresponding items for the "after" state.
        Each item should be a brief description of the state or condition.
        Optionally, create a conclusion or takeaway for the slide.`;
    }

    getModelHints() {
        return {
            slideType: "before and after comparison",
        };
    }

    getPromptSchema() {
        return {
            beforeLabel: "optional custom label for the before column (defaults to 'Before')",
            afterLabel: "optional custom label for the after column (defaults to 'After')",
            beforeItems: ["array of richtext describing the before state"],
            afterItems: ["array of richtext describing the after state"],
            conclusion: "an optional short conclusion or takeaway for the slide",
        };
    }

    getSlideModels(model, options = {}) {
        let models = [
            this.buildBeforeAfterSlide(model, options),
            this.buildBeforeAfterTextBoxGrid(model, options)
        ];
        return models;
    }

    buildBeforeAfterSlide(model) {
        let builder = new SlideModelBuilder("textlist", model);
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        const cols = 2;
        const listStyle = ListStyleType.BULLET;

        // Create before column
        const beforeCol = {
            isMedia: false,
            text: {
                blocks: []
            }
        };

        // Add before items
        if (model.beforeItems && model.beforeItems.length > 0) {
            beforeCol.text.blocks = model.beforeItems;
            // for (let item of model.beforeItems) {
            //     beforeCol.text.blocks.push(
            //         builder.createBlock(item, TextStyleType.BULLET_LIST, { listStyle, bulletColor: null, indent: 0 })
            //     );
            // }
        }

        // Create after column
        const afterCol = {
            isMedia: false,
            text: {
                blocks: []
            }
        };
        // Add after items
        if (model.afterItems && model.afterItems.length > 0) {
            afterCol.text.blocks = model.afterItems;
            // for (let item of model.afterItems) {
            //     afterCol.text.blocks.push(
            //         builder.createBlock(item, TextStyleType.BULLET_LIST, { listStyle, bulletColor: null, indent: 0 })
            //     );
            // }
        }

        const items = [beforeCol, afterCol];

        builder.createPrimary({
            collectionColor: "theme",
            listStyle,
            showColumnHeaders: true,
            items
        });

        // Add column headers
        builder.model.states[0].primary.columnHeader0 = {
            blocks: [
                builder.createBlock(model.beforeLabel || "Before", TextStyleType.TITLE, { listStyle: ListStyleType.TEXT })
            ]
        };

        builder.model.states[0].primary.columnHeader1 = {
            blocks: [
                builder.createBlock(model.afterLabel || "After", TextStyleType.TITLE, { listStyle: ListStyleType.TEXT })
            ]
        };

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion);
        }

        return builder.model;
    }

    buildBeforeAfterTextBoxGrid(model) {
        let builder = new SlideModelBuilder("textBoxGrid", model);
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        // Create before box
        const beforeBox = {
            color: "theme",
            // text: {
            //     blocks: [
            //         builder.createBlock(model.beforeLabel || "Before", TextStyleType.TITLE),
            //         builder.createBlock(this.formatItemsAsText(model.beforeItems), TextStyleType.BODY)
            //     ]
            // }
            text: {
                blocks: model.beforeItems
            }
        };

        // Create after box
        const afterBox = {
            color: "accent1",
            // text: {
            //     blocks: [
            //         builder.createBlock(model.afterLabel || "After", TextStyleType.TITLE),
            //         builder.createBlock(this.formatItemsAsText(model.afterItems), TextStyleType.BODY)
            //     ]
            // }
            text: {
                blocks: model.afterItems
            }
        };

        const items = [beforeBox, afterBox];

        builder.createPrimary({
            collectionColor: "theme",
            flipOrientation: false,
            fitToText: false,
            items
        });

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion);
        }

        return builder.model;
    }

    formatItemsAsText(items) {
        if (!items || items.length === 0) {
            return "";
        }
        // Format items as bullet points with HTML line breaks
        return items.map(item => `• ${item}`).join("<br/>");
    }
}
